import { FULL_NAME, IS_NOT_NULL_OR_UNDEFINED } from '../../utils';
import { QuickSearchAccountResult } from '../views/quick-search-account-result';
import { Account } from './../../account/dtos/account';

export const QUICK_SEARCH_ACCOUNTS_TABLE = (accounts: Account[]): QuickSearchAccountResult[] => {
	const result = [] as QuickSearchAccountResult[];
	try {
		accounts?.forEach((account) => {
			const searchResult = {} as QuickSearchAccountResult;
			searchResult.id = account.id;
			searchResult.businessName = account.businessName;
			searchResult.mc = account.mc;
			searchResult.dot = account.dot;
			if (IS_NOT_NULL_OR_UNDEFINED(account.users)) {
				const user = account.users[0];
				if (IS_NOT_NULL_OR_UNDEFINED(user)) {
					searchResult.contactName = FULL_NAME(user.firstName, user.lastName);
					searchResult.contactPhone = user.phoneNumber;
					searchResult.contactEmail = user.email;
				}
			}
			result.push(searchResult);
		});
	} catch (error) {
		console.log('QUICK_SEARCH_ACCOUNTS_TABLE error: ', error);
	}
	return result;
};
